import React, { Fragment } from "react";

import img13 from "../../../images/service/Education Blockchain Development/1.png";
import img14 from "../../../images/service/Education Blockchain Development/2.png";
import img15 from "../../../images/service/Education Blockchain Development/3.png";

// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Digital Certificate Verification",
    content:
      "Issue and verify academic certificates on blockchain to prevent fraud and enable instant validation.",
  },
  {
    icon: sIcon2,
    title: "Student Record Management",
    content:
      "Securely manage student data, transcripts, and achievements with tamper-proof blockchain records.",
  },
  {
    icon: sIcon3,
    title: "Smart Contract Automation",
    content:
      "Automate admissions, fee payments, and credential issuance using smart contracts.",
  },
];

const benefits = [
  {
    title: "Fraud Prevention",
    description:
      "Blockchain eliminates fake degrees and certificates by ensuring immutable academic records.",
    icon: sIcon1,
  },
  {
    title: "Data Security",
    description:
      "Student and institutional data remain encrypted and protected from unauthorized access.",
    icon: sIcon2,
  },
  {
    title: "Global Verification",
    description:
      "Educational credentials can be verified instantly from anywhere in the world.",
    icon: sIcon3,
  },
  {
    title: "Operational Efficiency",
    description:
      "Automation reduces administrative overhead and manual verification processes.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "How does blockchain benefit the education sector?",
    a: "Blockchain secures academic records, prevents certificate fraud, and enables transparent credential verification.",
  },
  {
    q: "Can blockchain store student records safely?",
    a: "Yes. Blockchain uses encryption and decentralization to protect sensitive student information.",
  },
  {
    q: "Is blockchain useful for online education platforms?",
    a: "Absolutely. Blockchain supports secure credential issuance, payments, and learner identity management.",
  },
  {
    q: "Can educational institutions adopt blockchain gradually?",
    a: "Yes. Blockchain solutions can integrate with existing education management systems.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function EducationBlockchainDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Education Blockchain Development"
        pagesub="Secure, transparent, and future-ready education solutions"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Transform Education with{" "}
            <span className="gradient-text">Blockchain Technology</span>
          </>
        }
        subtitle={`Empower educational institutions with secure data management,
fraud-proof credentials, and transparent learning ecosystems using blockchain.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Education Blockchain Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="Why Blockchain in Education?"
        image={img14}
        paragraphs={[
          "Educational institutions manage large volumes of sensitive data including student records, certificates, and academic achievements. Traditional systems are vulnerable to fraud, data breaches, and verification delays.",
          "Blockchain introduces a decentralized and immutable framework that ensures data integrity, enhances trust, and simplifies credential verification across educational ecosystems.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Education Blockchain Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Challenges in Traditional Education Systems"
        image={img15}
        paragraphs={[
          "Manual verification processes, certificate forgery, and fragmented data systems create inefficiencies for institutions, employers, and students.",
          "Blockchain solves these challenges by providing a secure digital infrastructure for storing, sharing, and verifying educational credentials.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Blockchain in Education"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Education Blockchain Solutions"
        subtitle="Designed for trust, security, and academic transparency"
        features={[
          {
            icon: sIcon1,
            title: "Immutable Academic Records",
            description:
              "Ensure permanent, tamper-proof storage of certificates and transcripts.",
          },
          {
            icon: sIcon2,
            title: "Decentralized Identity",
            description:
              "Enable students to control access to their educational credentials.",
          },
          {
            icon: sIcon3,
            title: "Smart Contract Automation",
            description:
              "Automate credential issuance, payments, and academic workflows.",
          },
          {
            icon: sIcon4,
            title: "Global Accessibility",
            description:
              "Verify academic achievements instantly across borders.",
          },
          {
            icon: sIcon5,
            title: "System Integration",
            description:
              "Integrate blockchain seamlessly with existing education platforms.",
          },
          {
            icon: sIcon6,
            title: "Scalable Infrastructure",
            description:
              "Support institutions of all sizes with scalable blockchain solutions.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Proven expertise in education-focused blockchain solutions",
          "Security-first and compliance-driven approach",
          "End-to-end support from strategy to deployment",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
